/**
 * Compile-time identity of the app mounting the provider. Each app is a
 * separate build, so this is passed as a required prop (not read from env)
 * and is the only reliable signal that separates officer from admin, since
 * both use the identical `MA&UD_ADMIN` client enum.
 */
export enum FeatureToggleAppId {
   Portals = 'PORTALS',
   BpsOfficer = 'BPS_OFFICER',
   Admin = 'ADMIN',
   Crm = 'CRM'
}

/**
 * The resolved scope suffix appended to each captcha gate name. One value per
 * pre-migration build/portal that could independently toggle captcha via its
 * own `.env` file. `Unknown` is used when identity cannot be resolved; no gate
 * named `*_unknown` exists in the console, so it evaluates `:Unrecognized` and
 * the fail-secure rule keeps captcha ON.
 */
export enum CaptchaGateScope {
   Citizen = 'citizen',
   Architect = 'architect',
   Ltp = 'ltp',
   OpenTdr = 'open_tdr',
   TdrBank = 'tdr_bank',
   TgiicClu = 'tgiic_clu',
   DigiPortal = 'digi_portal',
   Officer = 'officer',
   Admin = 'admin',
   Crm = 'crm',
   Unknown = 'unknown'
}

/**
 * Inputs to the pure scope resolver. `Config` is untyped, so the portal
 * signals are optional strings.
 */
export interface ResolveCaptchaGateScopeArgs {
   appId: FeatureToggleAppId
   clientEnum?: string // Config.APP_CLIENT_ENUM
   portalType?: string // Config.PORTAL_TYPE
   portalSubType?: string // Config.PORTAL_SUB_TYPE
}
